import appConfig from '../../config/app';
import { getAuthHeaders } from './auth';

export const fetchUserAccomplishments = async (userUid) => {
  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/users/${userUid}/accomplishments`,
    { headers: await getAuthHeaders() },
  );

  if (!response.ok) {
    throw new Error('Failed to fetch accomplishments');
  }

  return response.json();
};
